var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page && _vm.page.content.length > 0 && _vm.page.totalElements > _vm.page.size)?_c('section',{staticClass:"pagination-mobile d-flex d-md-none"},[_c('b-pagination',{staticClass:"w-100 mb-0",attrs:{"align":"fill","per-page":_vm.page.size,"total-rows":_vm.page.totalElements,"value":_vm.page.number + 1},on:{"input":_vm.pageChanged}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }